export default "__VITE_ASSET__CwN46kGr__"